import { Ingredient } from '@cf-shared/data-model/ingredient';
import { deepClone } from '@cf-shared/deep-helpers';

/**
 * Works out what a meal's ingredient list becomes after the user copies the same meal
 * from an earlier day into it ("Copy From a Day" on the meal screen).
 *
 * The copied ingredients are ADDED to whatever the meal already holds; nothing already
 * logged is deleted and the user is not asked to choose (mh-physique#4969, settled by the
 * product owner on 27 August 2026). This screen is the "add food" page, so a food already
 * on it is one the user ate or means to eat.
 *
 * A NEW array is returned rather than the caller's own, because the meal screen uses
 * OnPush change detection and only re-renders the ingredient list when the array identity
 * changes.
 *
 * The copied ingredients are always CLONED. The list the caller hands in as `copiedFrom`
 * belongs to the earlier day's saved meal -- the database hands back one shared object per
 * document (the identity map), and the ingredient list on the meal screen edits its array
 * in place. Without the clone, every later edit to today's meal would silently rewrite the
 * older day's logged meal too.
 */
export function mergeCopiedMealIngredients(
  alreadyInThisMeal: Ingredient[],
  copiedFrom: Ingredient[],
): Ingredient[] {
  return [...alreadyInThisMeal, ...deepClone(copiedFrom)];
}
